import { render } from "./ProposalsDashboardV2.vue?vue&type=template&id=57fa94b1&scoped=true"
import script from "./ProposalsDashboardV2.vue?vue&type=script&lang=js"
export * from "./ProposalsDashboardV2.vue?vue&type=script&lang=js"

import "./ProposalsDashboardV2.vue?vue&type=style&index=0&id=57fa94b1&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fa94b1"]])

export default __exports__